import { NgIf } from '@angular/common';
import { Component, InputSignal, OnDestroy, OnInit, input } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BreadcrumbComponent, IBreadcrumbNode, IBreadcrumbRoot } from '../breadcrumb/breadcrumb.component';
import { HeaderBreadcrumbManager } from './header-breadcrumb-manager';

@Component({
  imports: [BreadcrumbComponent, NgIf],
  selector: 'scw-header-breadcrumb',
  standalone: true,
  templateUrl: './header-breadcrumb.component.html',
})
export class HeaderBreadcrumbComponent implements OnInit, OnDestroy {
  public readonly manager: InputSignal<HeaderBreadcrumbManager> = input.required<HeaderBreadcrumbManager>();
  public breadcrumbNodes: IBreadcrumbNode[] = [];
  public root: IBreadcrumbRoot | undefined;

  private subscription?: Subscription;

  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService,
  ) {}

  public ngOnInit(): void {
    this.subscription = this.manager().nodes$.subscribe((nodes) => {
      this.breadcrumbNodes = nodes;
    });

    let child: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;

    while (child.firstChild) {
      child = child.firstChild;
    }

    this.root = {
      icon: child.data?.['icon'],
      title: child.data?.['title'] ? this.translate.instant(child.data['title']) : '',
    };
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public onBreadcrumbClicked(node?: IBreadcrumbNode): void {
    this.manager().notifyNodeClicked(node);
  }
}
